import React from 'react';
import PropTypes from 'prop-types';
import ButtonSecondary from '../ButtonSecondary';
import './styles.scss';

const ButtonSecondaryCompact = ({ classNames = [], ...props }) => (
    <ButtonSecondary {...props} classNames={['custom-btn-secondary-compact', ...classNames]} />
);

ButtonSecondaryCompact.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonSecondaryCompact;
